// Google Ads conversion tracking.
// Loads the gtag.js library once (based on site settings) and exposes
// a simple function to fire a conversion event, e.g. on a completed
// booking or a WhatsApp click.

let loadedForId = null;

// Injects the Google Ads gtag.js script tag and initializes it.
// Safe to call multiple times — only loads once per Google Ads ID.
export const initGoogleAds = (googleAdsId) => {
  if (!googleAdsId) return;
  if (typeof window === "undefined") return;
  if (loadedForId === googleAdsId) return;
  loadedForId = googleAdsId;

  if (!window.dataLayer) window.dataLayer = [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", googleAdsId);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
  document.head.appendChild(script);
};

// Fires a Google Ads conversion event. `sendTo` is the full
// "AW-XXXXXXXXXX/LABEL" string for a specific conversion action.
export const fireGoogleAdsConversion = (sendTo) => {
  if (!sendTo) return;
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo });
};
